'use strict';

const SpaceManager = require('ck-core/source/managers/SpaceManager');
const ClientModule = require('../system/ClientModule');

module.exports = ClientModule.define(SpaceManager, {
	type: 'ClientSpaceManager'
});
